import { render, staticRenderFns } from "./UiRadio.vue?vue&type=template&id=e077500a&scoped=true&"
import script from "./UiRadio.vue?vue&type=script&lang=js&"
export * from "./UiRadio.vue?vue&type=script&lang=js&"
import style0 from "./UiRadio.vue?vue&type=style&index=0&id=e077500a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e077500a",
  null
  
)

export default component.exports